import moment from "moment";
import { FETCH_APPOINTMENT_TIME } from "./ActionTypes";

const initialState = {
  date: moment(new Date()).format("YYYY-MM-DD")
 
};

const Appointmentreducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPOINTMENT_TIME:
      return {
        date: action.payload,
      };


    default:
      return state;
  }
};

export default Appointmentreducer;
